import React, { useState } from 'react'
import Dialog from '@mui/material/Dialog'

import { Button } from '../../../components/UI'
import FindTutorCalendarView from './FindTutorCalendarView'

import { getUserName } from '../../../helpers'

import '../../student/CalendarView/calendar.css'

const FindTutorCalendar = ({ open, onClose, onContinue, classBanner }) => {
  const [selectedSlot, setSelectedSlot] = useState(null)

  return (
    <Dialog
      open={open}
      onClose={onClose}
      scroll="body"
      fullWidth
      classes={{
        paper: 'relative xl:!max-w-[1200px] !p-[32px] !rounded-[10px] !bg-[#FEEBDD] !shadow-modal',
      }}
    >
      {classBanner && (
        <div className="w-full flex flex-col items-center justify-center">
          <h2 className="text-2xl font-bold text-primary-100">
            {getUserName(
              classBanner.class_banner_creator,
              classBanner.creator_profile?.display_name,
              classBanner.creator_profile?.display_last_name
            )}{' '}
            · {classBanner.class_banner_category?.name}
          </h2>

          <FindTutorCalendarView
            classBanner={classBanner}
            selectedSlot={selectedSlot}
            setSelectedSlot={setSelectedSlot}
          />

          <div className="w-full flex items-start justify-between mt-[16px]">
            <div className="flex items-center">
              <div className="flex items-center">
                <div className="mr-[14px] w-[20px] h-[20px] bg-[#1AC057] rounded-[3px]" />

                <span className="text-base font-normal text-primary-100">Available time slots</span>
              </div>
            </div>

            <div className="flex items-center">
              <button
                onClick={onClose}
                className="w-[200px] rounded-lg h-[44px] mr-[10px] px-6 bg-white text-[#F79009] border-[1px] border-[#F79009] font-semibold hover:text-white hover:!border-primary-button-hover hover:!bg-primary-button-hover transition-colors duration-200 ease"
              >
                Cancel
              </button>

              <Button
                className="w-[200px] font-semibold"
                onClick={() => onContinue(selectedSlot)}
                disabled={!selectedSlot}
              >
                Continue
              </Button>
            </div>
          </div>
        </div>
      )}
    </Dialog>
  )
}

export default FindTutorCalendar
